import axiosInstance from "services/AxiosInstance";

export const putApproveImportService = async (id: string) => {
  const response = await axiosInstance.put(`/imports/${id}/analysis/approval`);
  return response.data;
};
